module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left media-middle"
  }, [_c('a', {
    staticStyle: {
      "color": "black",
      "display": "inline"
    },
    attrs: {
      "href": "javascript://",
      "tabindex": "0",
      "role": "button",
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "left",
      "title": _vm.tooltipTitle(),
      "data-content": _vm.tooltipContent()
    },
    on: {
      "click": function($event) {
        _vm.editModus = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg",
    class: [_vm.completionSymbol(_vm.history.completion)],
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.getDateTime(_vm.history.datetimeBegin)))]), _vm._v("\n        - " + _vm._s(_vm.history.userCallerName) + " "), (_vm.modeActiveCall) ? _c('span', [_vm._v("(" + _vm._s(_vm.history.companyCallerName) + ")")]) : _vm._e(), _vm._v(", für " + _vm._s(_vm.history.userClientName) + "  "), (!_vm.modeActiveCall) ? _c('span', [_vm._v(", " + _vm._s(_vm.history.companyClientName) + "(" + _vm._s(_vm.history.calledNumber) + ")")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cc-msg",
    staticStyle: {
      "max-width": "45em"
    }
  }, [_c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.history.message),
      expression: "!history.message"
    }]
  }, [_c('i', [_vm._v("- kein Nachricht hinterlegt -")])]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.history.message))])])]), _vm._v(" "), _c('div', {
    staticClass: "media-right text-right media-middle"
  }, [_c('button', {
    staticClass: "btn  btn-link cc-btn-menue",
    attrs: {
      "type": "button",
      "title": "Eintrag bearbeiten"
    },
    on: {
      "click": function($event) {
        _vm.editModus = true
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-option-vertical"
  })])])]), _vm._v(" "), (_vm.editModus) ? _c('cc-message-modal', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.tooltipTitle())
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.tooltipContent())
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Kommentar zum Call:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "placeholder": "Kommenta zum Call eingeben..."
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.comment) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.onClickSave
    }
  }, [_vm._v("Speichern")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.editModus = false
      }
    }
  }, [_vm._v("Schließen")])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3fb6b198!./~/vue-loader/lib/selector.js?type=template&index=0!./src/HistoryItem.vue
// module id = 270
// module chunks = 0